
const prod = {
    //GraphQlUrl: "https://white-sunset.us-east-1.aws.cloud.dgraph.io/graphql",
    GraphQlUrl: "https://delicate-voice.us-east-1.aws.cloud.dgraph.io/graphql",
    Auth0_ClientId: "RK87tkmsNVO7fzliMspwZuHMD5PC9BSV",
    //Auth0_RoleId: "rol_V3ZlDwLSzqZzxjXe",
    Auth0_Audience: "https://travelsment.us.auth0.com/api/v2/",
    Auth0_domain: "travelsment.us.auth0.com",
    ReactGA: "G-VXSYNEE5XH",
    url: 'https://trip.travelsment.com',
    email: 'info@familytc.com',
    subEmail: ['vladimir.r@bachoodesign.com', 'boris.stambler@yahoo.com'],
    base_url: 'https://travelsment.us.auth0.com',
    base_api: 'https://trip.travelsment.com/api'
};

const dev = {
    url: 'https://dev.travelsment.com',
    GraphQlUrl: "https://blue-surf-590149.us-east-1.aws.cloud.dgraph.io/graphql",
    Auth0_ClientId: "F1aN0P253OYhj004gc93v9uD5DGCQBtU",
    //Auth0_RoleId: "rol_fN6dHIh21S99Fbid",
    Auth0_Audience: "https://dev-b8dnjx5d.us.auth0.com/api/v2/",
    Auth0_domain: "dev-b8dnjx5d.us.auth0.com",
    ReactGA: "G-RTYR7G1DV3",
    email: 'boris.stambler@yahoo.com',
    subEmail: ['aromalmohan@netstratum.com', 'vladimir.r@bachoodesign.com'],
    base_url: 'https://dev-b8dnjx5d.us.auth0.com',
    base_api: 'https://dev.travelsment.com/api'
};

export function getENVData() {
    if (window.location.hostname === "trip.travelsment.com") {
        return prod
    } else {
        return dev
    }
}

export function isDev() {
    return window.location.hostname !== "trip.travelsment.com";
}

export const isLocalDev = window.location.hostname.indexOf("travelsment.com") === -1;
